import { RouteType } from "types/RouteType";
import LaborTimeTrackingWizardStore from "./LaborTimeTrackingWizardStore";

const LaborTimeTrackingWizardRoute: RouteType = {
  name: "LaborTimeTrackingWizard",
  path: "/workflows/labor-time-tracking",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Labor Time Tracking",
      component: () => import("./LaborTimeTrackingWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./LaborTimeTrackingWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.laborTimeTrackingWizardStore) {
      rootStore.laborTimeTrackingWizardStore = new LaborTimeTrackingWizardStore(
        rootStore
      );
    }
    await rootStore.laborTimeTrackingWizardStore.loadInitialData();
    return true;
  },
};

export default LaborTimeTrackingWizardRoute;